import React, {useEffect, useRef, useState} from 'react';
import Icon from "../Icon";
import MediaDatas from "./components/MediaDatas";
import AlbumInformations from "../AlbumInformations";
import UploadMultipleGallery from "./UploadMultipleGallery";
import createLink from "../../../libs/createLink";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {fetchUserAlbums, USER_ALBUMS_KEY, USER_CURRENT_KEY} from "../../../api/public-voissa/users";
import {useNavigate} from "react-router-dom";
import {fetchTagsMedia, TAGS_MEDIA_KEY} from "../../../api/public-voissa/tags";
//import {fetchTagsMedia} from "../../../creators/tagsMedia";
import {ALBUM_MEDIAS_KEY, createMediaAlbum} from "../../../api/public-voissa/albums";
import useUpload from "../../../hooks/useUpload";
import './Uploads.scss';
import Drawer from "../../components2/Drawer/Drawer";
import {COLLECTION_VISIBILITY} from "../../../const/collections";
import Select from "../../components2/UI/Select/Select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/pro-regular-svg-icons";
import Button, {BUTTON_VARIANTS} from "../../components2/UI/Button/Button";
import InputGroup from '../../components2/UI/InputGroup/InputGroup';
import TextError from "../../components2/UI/TextError/TextError";
import convertToNext from "../../../libs/lexical/convertissors/simple";

const Uploads = ({
        currentAlbumId = 0,
        handleClose = () =>{}
    }) =>{

    const queryClient = useQueryClient();
    const navigate = useNavigate();

    let refUploadInput = useRef();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);

    const {data : dataAlbums} = useQuery(
        [USER_ALBUMS_KEY, dataCurrentUser._id, {limit : false}],
        ()=> fetchUserAlbums(dataCurrentUser._id, {limit : false}),
        {
            staleTime : (1000 * 60 * 5),
            enabled : !!dataCurrentUser._id,
            placeholderData : [],
            select : data => data.data || []
        }
    );

    const {data : dataTags} = useQuery(
        [TAGS_MEDIA_KEY],
        ()=> fetchTagsMedia(),
        {
            staleTime : (1000 * 60 * 5),
            placeholderData : [],
            select : (data) =>data.data || [],
        }
    );

    let tags = dataTags || [];

    const {
        mutate : mutateCreateMediaAlbum,
    } = useMutation((data) => createMediaAlbum(albumId, data), {
        onSuccess : async () =>{
            await queryClient.invalidateQueries([ALBUM_MEDIAS_KEY, albumId]);
        }
    });

    const {data : dataUploads, totalLoading, totalSuccess, uploads, cancelUploadFile} = useUpload("/medias/upload", {isUploadMultiple : true});


    const [currentEphemeralId, setCurrentEphemeralId] = useState("");
    const [albumId, setAlbumId] = useState(currentAlbumId || 0);
    const [metaData, setMetadata] = useState({});

    const [toggleCreateAlbum, setToggleCreateAlbum] = useState(false);
    const [toggleWarningAlbum, setToggleWarningAlbum] = useState(false);


    function handleUpdateContent(editState) {
        let {text, links, mentions} = convertToNext(editState);
        let data = metaData[currentEphemeralId] || {title : "", legend : "", mentions : [], links : []};
        setMetadata({...metaData, [currentEphemeralId] : {...data, legend: text, links, mentions }});
    }

    async function handleFiles(){
        let newFiles = refUploadInput.current.files;
        //newFiles = Object.values(newFiles);
        await uploads(newFiles);
        refUploadInput.current.value = "";
    }

    function _handleCloseAlbumInformations(){
        setToggleCreateAlbum(false);
        if (!dataAlbums.length) handleClose();
    }

    function handleSubmit() {
        let numberOfInvalideElement = 0;
        let fileUploading = dataUploads.filter(item => item.isSuccess);
        fileUploading.forEach((file) => {
            if(!metaData[file.ephemeralId] || (metaData[file.ephemeralId] && !metaData[file.ephemeralId].legend)){
                if(numberOfInvalideElement === 0){
                    setCurrentEphemeralId(file.ephemeralId);
                }
                numberOfInvalideElement++;
            }
        });

        if(albumId !== 0 && numberOfInvalideElement === 0){
            fileUploading = fileUploading.map(file => {
                let data = metaData[file.ephemeralId];
                return {
                    tmpId : file.res._id,
                    //title : data.title,
                    legend : data.legend,
                    mentions : data.mentions || [],
                    links : data.links || []
                };
            });

            let album = dataAlbums.filter(album => album._id === albumId);

            mutateCreateMediaAlbum({medias : fileUploading});
            navigate(createLink('userMeCollection', {
                ...dataCurrentUser,
                album : {_id: albumId, slug: album[0].slug}
            }));
            handleClose();
        } else {
            setToggleWarningAlbum(true);
        }
    }


    useEffect(() => {
        if(currentEphemeralId === ""){
            let nextIndexCurrentMedia = dataUploads.findIndex(item => item.isSuccess);
            if(nextIndexCurrentMedia >= 0){
                setCurrentEphemeralId(dataUploads[nextIndexCurrentMedia].ephemeralId);
            }
        };
        if(currentEphemeralId !== "" && totalSuccess === 0){
            setCurrentEphemeralId("");
        };
    }, [dataUploads, currentEphemeralId, totalSuccess]);


    const albumOptions = dataAlbums.map(album =>{
        return {
            value : album._id,
            label : `${album.title} (${COLLECTION_VISIBILITY.find(item => item.value === album.right).label})`
        }
    });

    albumOptions.unshift({value : "0", label : "Choisir une collection"});

    return (
        <div id="uploads" >
                <div className="uploads-header">
                    <InputGroup>
                        <Select
                            options={albumOptions}
                            onSelect={({value})=>setAlbumId(value)}
                            selectedValue={albumId}
                        />
                        <Button onClick={()=>setToggleCreateAlbum(!toggleCreateAlbum)} active={toggleCreateAlbum} variant={BUTTON_VARIANTS.REVERSE}>
                            <FontAwesomeIcon icon={faPlus}/> Nouvelle
                        </Button>
                    </InputGroup>

                </div>
                <TextError show={toggleWarningAlbum} >{albumId === 0 ? "Vous devez choisir une collection" : "Vous devez completer les informations sur les medias en rouge"}</TextError>
                <div className={"media-list"}>
                    <input
                        type="file"
                        id="multipleUploadInput"
                        accept="image/jpeg, image/png, image/gif, video/mp4, video/flv, video/mpeg, video/mkv, video/mov, video/qt, video/quicktime, video/wmv, video/avi"
                        style={{display: 'none'}}
                        multiple
                        ref={refUploadInput}
                        onChange={(file)=> handleFiles(file) }
                    />

                    <label htmlFor={"multipleUploadInput"} className={"media-block upload"} >
                        <FontAwesomeIcon icon={faPlus} />
                    </label>

                    {dataUploads.map((item, index) => {
                        if (!item.isCancel && !item.isSuccess) {
                            return (
                                <UploadMultipleGallery
                                    {...item}
                                    cancelFile={() => cancelUploadFile(item.ephemeralId)}
                                    key={index}
                                />
                            )
                        }
                        else if (item.isSuccess) {
                            return(<div className={`media-block ${(metaData[currentEphemeralId] && metaData[currentEphemeralId].title && metaData[currentEphemeralId].length === 0)  ? 'error' : ''} 
                                            ${currentEphemeralId === item.ephemeralId ? 'active' : ''}`}
                                        key={index}>
                                <div className={"white-borders"}
                                     onClick={()=> {
                                         setCurrentEphemeralId(item.ephemeralId);
                                     } }
                                     style={{backgroundImage: `url(${item.res.preview ? `${item.res.preview}?width=200` : ""})`}} />
                                {(metaData[currentEphemeralId] && metaData[currentEphemeralId].title && metaData[currentEphemeralId].title.length === 0) && (
                                    <div className={"missing-informations"}>!</div>
                                )}
                                <span className={"close-button"} onClick={()=>cancelUploadFile(item.ephemeralId)}><Icon type={"close"}/></span>
                                {item.res.kind === "video" && <div className={"video-play-button"}><Icon type={"play"}/></div>}
                            </div>)
                        }
                        else{
                            return null;
                        }
                    })}
                </div>
                {currentEphemeralId !== "" && (
                    <MediaDatas
                        tagsMedia={tags}
                        currentMediaIndex={currentEphemeralId}
                        media={metaData[currentEphemeralId] || {title : "", legend : "", mentions: []} }
                        handleUpdateContent={handleUpdateContent}
                        //handleTags={(key, value) => handleCurrentMediaDatas(key, value) }
                        isUpload={true}
                    />
                )}

                <div className={`uploads-footer ${!!currentEphemeralId ? "active" : ""}`}>
                    <Button
                        active={toggleCreateAlbum}
                        variant={BUTTON_VARIANTS.REVERSE}
                        disabled={totalLoading === 0 && totalSuccess === 0}
                        onClick={()=>totalLoading === 0 && totalSuccess > 0 ? handleSubmit() : null}
                    >
                        {totalLoading === 0 ? "Publier" : `Il y a encore ${totalLoading} publications en cours d'upload`}
                    </Button>
                </div>
      
            <Drawer
                open={toggleCreateAlbum}
                handleClose={_handleCloseAlbumInformations}
                headContent={`Nouvelle collection`}
            >
                <AlbumInformations
                    createAlbum={true}
                    userId={dataCurrentUser._id}
                    handleClose={() => setToggleCreateAlbum(false) }
                />
            </Drawer>
        </div>
    )
};

export default Uploads;